import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { isNil, isNumber } from 'lodash';
import styles from './InputNumber.module.scss';
import cn from '../../../utils/tools/cn';

function InputNumber({
  label, name, setFieldValue, min, max, value, isDisabled, isInsideTable,
}) {
  const [inputValue, setInputValue] = useState(value);

  const handleChange = (_val) => {
    let val = _val;
    if (val < 0) val = min;
    let newValue = min;

    if (!isNil(val) && isNumber(val)) {
      if (!isNil(min) && (val < min)) {
        newValue = min;
      } else if (!isNil(max) && (val > max)) {
        newValue = max;
      } else {
        newValue = val;
      }
    }

    setInputValue(newValue);
  };

  useEffect(() => {
    if (value !== inputValue) setFieldValue(name, inputValue);
  }, [inputValue]);

  useEffect(() => {
    if (value !== inputValue) setInputValue(value);
  }, [value]);

  return (
    <div className="d-flex d-col">
      {label ? (
        <p className="c-neutral-03 fs-16 m-b-15 fw-300">{label}</p>
      ) : null}

      <div className={cn([styles.wrapper, 'd-flex a-center', isInsideTable ? styles.inside_table : ''])}>
        <button
          type="button"
          onClick={() => handleChange(inputValue - 1)}
          disabled={isDisabled || (!isNil(min) && inputValue === min)}
          className={styles.edit_button}
        >
          <span className={styles.minus} />
        </button>

        <div className={styles.input}>
          <input
            name={name}
            type="number"
            value={Number(inputValue).toString()}
            onChange={(e) => handleChange(e?.target?.value ? parseInt(e.target.value, 10) : null)}
            pattern="[0-9]*"
            disabled={isDisabled}
          />
          <span className={styles.holder}>
            {Number(inputValue).toString()}
          </span>
        </div>

        <button
          type="button"
          onClick={() => handleChange(inputValue + 1)}
          disabled={isDisabled || (!isNil(max) && inputValue === max)}
          className={styles.edit_button}
        >
          <span className={styles.plus} />
        </button>
      </div>
    </div>
  );
}

InputNumber.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  setFieldValue: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  isDisabled: PropTypes.bool,
  isInsideTable: PropTypes.bool,
};

InputNumber.defaultProps = {
  label: null,
  name: '',
  setFieldValue: () => {},
  min: 0,
  max: null,
  value: 0,
  isDisabled: false,
  isInsideTable: false,
};

export default InputNumber;
